import { PD_RANGE_BY_FRAME_SIZE } from 'constants/pdRange';
import { UPDATE_PRESCRIPTION_PD_BY_ID } from 'gqlStrings/mutations/Prescription';
import { GET_PDS } from 'gqlStrings/queries/getPrescriptions';
import { client as wcApiApolloClient } from '../apolloclient';
import axios from 'axios';

const prescriptionService = {
  async findAllPds(frameSize?: string) {
    const { data } = await wcApiApolloClient.query({
      query: GET_PDS,
      context: { clientName: 'laravel' }
    });
    if (!frameSize) return data.me.pds.data;

    return data.me.pds.data.filter((userPd: any) => {
      if (!frameSize) return true;

      return this.checkIsPdInFrameSizeRange(frameSize, userPd);
    });
  },
  checkIsPdInFrameSizeRange(frameSize: string, pd: any) {
    if(!frameSize) return true;

    const pdRange = PD_RANGE_BY_FRAME_SIZE[frameSize];
    const isMonocular =
      pd?.right_monocular_dist_pd || pd?.left_monocular_dist_pd;

    if (!isMonocular)
      return (
        Number(pd.binocular_dist_pd) >= Number(pdRange.min) &&
        Number(pd.binocular_dist_pd) <= Number(pdRange.max)
      );

    return (
      Number(pd.left_monocular_dist_pd) >= pdRange.min / 2 &&
      Number(pd.left_monocular_dist_pd) <= pdRange.max / 2 &&
      Number(pd.right_monocular_dist_pd) >= pdRange.min / 2 &&
      Number(pd.right_monocular_dist_pd) <= pdRange.max / 2
    );
  },
  async updatePdById(payload: { prescriptionId: string; pdId: string }) {
    const { data } = await wcApiApolloClient.mutate({
      mutation: UPDATE_PRESCRIPTION_PD_BY_ID,
      variables: {
        input: {
          id: payload.prescriptionId,
          pdId: payload.pdId
        }
      },
      context: { clientName: 'laravel' }
    });
    return data;
  }
};

export const storeGuestPrescriptionToUser = async (
  prescriptionId: string,
  authToken: string,
  pdId?: string,
  maxRetries: number = 3
): Promise<boolean> => {
  if (!prescriptionId || !authToken) {
    console.warn('storeGuestPrescriptionToUser: Missing required parameters', { prescriptionId, authToken });
    return false;
  }

  let retryCount = 0;
  
  while (retryCount < maxRetries) {
    try {
      const url = process.env.NEXT_PUBLIC_LARAVEL_URL + 
        '/storeGuestPrescriptionToUser/' + 
        prescriptionId + 
        (pdId ? '?pd=' + pdId : '');
      
      const response = await axios.get(url, {
        headers: {
          Authorization: 'Bearer ' + authToken
        },
        timeout: 10000 // 10 second timeout
      });

      if (response.status === 200) {
        console.log('Successfully stored guest prescription to user:', prescriptionId);
        return true;
      } else {
        console.warn('storeGuestPrescriptionToUser: Unexpected response status:', response.status);
        retryCount++;
      }
    } catch (error: any) {
      retryCount++;
      console.error(`storeGuestPrescriptionToUser: Attempt ${retryCount} failed:`, error.message);
      
      // If it's the last retry, log the full error
      if (retryCount >= maxRetries) {
        console.error('storeGuestPrescriptionToUser: All retries failed for prescription:', prescriptionId, error);
        return false;
      }
      
      // Wait before retrying (exponential backoff)
      const delay = Math.min(1000 * Math.pow(2, retryCount - 1), 5000);
      await new Promise(resolve => setTimeout(resolve, delay));
    }
  }
  
  return false;
};

export default prescriptionService;
